import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { MaterialSymbol, TextField, withStyles } from 'vopay';
import styles from './PermissionsSearchField.module.scss';

const cn = withStyles(styles);

type PermissionsSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  name?: string;
  /** Defaults to the shared Search label. */
  placeholder?: string;
};

export default function PermissionsSearchField({
  value,
  onChange,
  name = 'permissionSearch',
  placeholder,
}: PermissionsSearchFieldProps) {
  const { t: tButtons } = useTranslation('translations', { keyPrefix: 'Shared.Buttons' });

  return (
    <TextField
      name={name}
      placeholder={placeholder ?? tButtons('search', { defaultValue: 'Search' })}
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      variant="outlineShadow"
      elementLeft={<MaterialSymbol icon="search" size="24px" className={cn('icon')} />}
    />
  );
}
